export default "__VITE_ASSET__BLdQuwc9__"